var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C7.3488 0.0031277 4.80708 1.0577 2.93239 2.93238C1.05771 4.80707 0.00313834 7.34879 1.0639e-05 9.99999C-0.00316471 12.1666 0.704538 14.2743 2.01455 16C2.01455 16 2.28728 16.3591 2.33183 16.4109L10 25.4545L17.6718 16.4063C17.7118 16.3582 17.9854 16 17.9854 16L17.9864 15.9973C19.2957 14.2724 20.0031 12.1656 20 9.99999C19.9969 7.34879 18.9423 4.80707 17.0676 2.93238C15.1929 1.0577 12.6512 0.0031277 10 0ZM10 13.6363C9.2808 13.6363 8.57774 13.4231 7.97975 13.0235C7.38175 12.6239 6.91567 12.056 6.64044 11.3916C6.36521 10.7271 6.2932 9.99596 6.43351 9.29057C6.57382 8.58519 6.92015 7.93725 7.42871 7.42869C7.93726 6.92014 8.5852 6.57381 9.29058 6.4335C9.99597 6.29319 10.7271 6.3652 11.3916 6.64043C12.056 6.91566 12.624 7.38174 13.0235 7.97974C13.4231 8.57773 13.6364 9.28079 13.6364 9.99999C13.6352 10.964 13.2517 11.8883 12.57 12.57C11.8883 13.2516 10.9641 13.6351 10 13.6363Z",
    fill: "#EFC155"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.cec676b20c19fe776001c5bb9ff3afc4.svg";
export { ForwardRef as ReactComponent };